<template>
<div class="chapter">
<div class="inner_page">
<div id="Epub4211-2.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="PN-I" id="toc_marker-3"><span class="char-style-override-2">Also by John Lawton</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">1963</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">Black Out</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">Old Flames</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">A Little White Death</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">Bluffing Mr. Churchill</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">Sweet Sunday</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">Flesh Wounds</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">Second Violin</span></p>
<p class="BT-1st-Para para-style-override-1"><span class="char-style-override-3">A Lily of the Field</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epub42112.vue?65692694